
export enum PaymentCategory
{
    Unset = "Unset",
    DepositAndBasket = "DepositAndBasket",
    Deposit = "Deposit",
    // DepositReturn = "DepositReturn",
    Basket = "Basket", // Rzeczy do zapłaty (wynajmy, zakupy, usługi, wszystko co było w koszyku)
    Transport = "Transport", // Np zwrot za jakieś nadmiarowe paczki
    // Return = "Return"
}
